import React from "react"
import RedSection from "../elements/RedSection"
import { useAutoAnimate } from "@formkit/auto-animate/react"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ERRORTYPES, MAX_PRODUCT_PRICE } from "../../config"
import { Context } from "../../store/store"
import Alert from "../elements/Alert"
import Spinner from "../elements/Spinner"
import Legal from "./Legal"
import { placeOrder } from "./OrderFct"
import Person from "./Person"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import Product from "./Product"
import BankAccount from "./BankAccount"
import Receipt from "../receipt/Receipt"
import Mafo from "./Mafo"

const Form = () => {
	const { globalState, dispatch } = useContext(Context)
	const [validation, setValidation] = useState({})
	const navigate = useNavigate()
	const [formError, setFormError] = useState<ERRORTYPES | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	function resetQuestion(key) {
		dispatch({
			type: "SET_ORDER_ENTRY",
			key: key,
			value: "",
		}) // strip HTML tags
	}
	function formElementChanged(e, key) {
		if (key === "question4" || key === "question6") {
			resetQuestion(key)
			let questionArrayValues = new Array()
			let allItems = document.querySelectorAll('input[name="' + key + '"]:checked')
			allItems.forEach(item => {
				let val = item.getAttribute("value")
				questionArrayValues.push(val)
			})
			dispatch({
				type: "SET_ORDER_ENTRY",
				key: key,
				value: questionArrayValues,
			})
		} else {
			if (e.target.type === "checkbox") {
				e.target.value = e.target.checked
			}
			dispatch({
				type: "SET_ORDER_ENTRY",
				key: key,
				value: e.target.value
					.replace(/(<([^>]+)>)/gi, "")
					.replace("https://www", "")
					.replace("mailto:", ""),
			}) // strip HTML tags
		}

		let isFieldInvalid = false

		const doc: any = document
		const elem = doc.querySelector("[name='" + key + "']:valid")
		if (elem === null) {
			console.log(elem)
			isFieldInvalid = true
		}

		// check for price maximum
		if (key === "purchaseAmount") {
			const price = parseFloat(e.target.value.replace(",", "."))
			if (price > MAX_PRODUCT_PRICE) {
				isFieldInvalid = true
			}
		}
		// check validation
		setValidation({ ...validation, ["invalid_" + key]: isFieldInvalid })
	}

	function submitOrder() {
		// create order part
		const orderSuccessCallback = extId => {
			setIsLoading(false)
			if (extId) {
				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "form-submit", "form-name": "particpate", "form-submit": false, field_error: "send" })
				} catch (e) { }

				navigate("/danke")
			} else {
				setFormError(ERRORTYPES.SERVER)
				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "form-submit", "form-name": "participate", "form-submit": true, package: globalState.package })
				} catch (e) { }
			}
		}
		const orderErrCallback = (tooManyAttemps: false, invalidCaptcha: false) => {
			setIsLoading(false)

			//TODO: Handling needs to be switched to error codes (BE part still open)
			if (tooManyAttemps) {
				setFormError(ERRORTYPES.MAXTRIES)
			} else if (invalidCaptcha) {
				setValidation({ ...validation, invalid_captcha: true })
				setFormError(null)
			} else {
				setFormError(ERRORTYPES.SERVER)
			}
			try {
				// eslint-disable-next-line
				let dataLayer = window["dataLayer"] || []
				dataLayer.push({ event: "form-submit", "form-name": "participate", "form-submit": true, package: globalState.package })
			} catch (e) { }
		}

		if (allInputFieldsValid()) {
			if (globalState.receiptReference) {
				setIsLoading(true)
				setFormError(null)
				placeOrder(globalState, setFormValidation, orderSuccessCallback, orderErrCallback)
			} else {
				setFormError(ERRORTYPES.UPLOADSMISSING)
			}
		} else {
			console.log("not all valid")
			if (globalState.question1 === "" || globalState.question2 === "" || globalState.question3 === "" || globalState.question4 === "") {
				setFormError(ERRORTYPES.VALIDATIONQUESTIONS)
				scrollToError()
			} else {
				setFormError(ERRORTYPES.FORMVALIDATION)
				scrollToError()
			}
		}
	}

	function isBicRequired() {
		return globalState.iban && globalState.iban.length > 2 && globalState.iban.substring(0, 2).toUpperCase() !== "DE"
	}

	function allInputFieldsValid() {
		// input names has to fit to variable classNames
		let isAllValid = true
		let invalidFields = {}

		// Special handing for bic. Bic is only for non DE IBANs required
		let fieldsToCheck: any = []
		if (isBicRequired()) {
			fieldsToCheck = Object.keys(globalState).filter(
				e =>
					e !== "package" &&
					e !== "captcha" &&
					e !== "captchaIdent" &&
					e !== "receiptReference" &&
					e !== "receiptFileName" &&
					e !== "privacy" &&
					e !== "price" &&
					e !== "salutation" &&
					e !== "question1Other" &&
					e !== "question2Other"
			)
		} else {
			fieldsToCheck = Object.keys(globalState).filter(
				e => e !== "package" && e !== "captcha" && e !== "captchaIdent" && e !== "receiptReference" && e !== "receiptFileName" && e !== "salutation" && e !== "bic"
			)
		}

		for (let index = 0; index < fieldsToCheck.length; index++) {
			const key = fieldsToCheck[index]

			const doc: any = document
			const elem = doc.querySelector("[name='" + key + "']:valid")
			if (elem === null) {
				isAllValid = false
				console.log(key)
				invalidFields["invalid_" + key] = true
			}
		}
		if (Object.keys(invalidFields).length) {
			console.log(invalidFields)
			setValidation({ ...validation, ...invalidFields })
		}

		return isAllValid
	}

	function setFormValidation(data: {}) {
		setValidation({
			...validation,
			...data,
		})
		scrollToError()
	}

	function scrollToError() {
		setTimeout(() => {
			try {
				const doc: any = document
				const { top } = doc.querySelector(".js-formerror").getBoundingClientRect()

				window.scrollTo({
					top: top + window.scrollY - 120,
					left: 0,
					behavior: "smooth",
				})
			} catch (error) { }
		}, 500)
	}

	return (
		<RedSection>
			<form
				onSubmit={e => {
					e.preventDefault()
					submitOrder()
				}}
				noValidate={true}
				className=""
				autoComplete={"off"}
			>
				<div className="grid grid-cols-1 ">
					<div>
						<div className="relative bg-[url(/src/bgimages/form-bg.png)] bg-cover pt-12 lg:pt-12">
							<div className="bg-norepeat  relative mx-auto  bg-contain bg-center bg-repeat-y">
								<div className="relative z-0 mx-auto -mt-[1px] grid  grid-cols-1 flex-col items-center">
									<div className="upload sogehts items-center  py-2 px-4 lg:py-12">
										<div className="mx-auto max-w-[1400px] " id="teilnehmen">
											<h2 className="mt-0 mb-6 text-center font-Alpro text-[36px] uppercase tracking-wider text-white md:mt-6 md:mb-4 lg:text-[58px]">JETZT MITMACHEN</h2>
											<p className="mx-auto text-center text-[18px] font-[500] leading-[22px] text-white lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]">
												Formular ausfüllen, Foto des Kassenbons hochladen und auf „Jetzt teilnehmen” klicken.
											</p>
										</div>
									</div>
								</div>
								<GoogleReCaptchaProvider language="de" useRecaptchaNet={true} reCaptchaKey="6LeoOywsAAAAAJSKNQJxBfRjnjLvdz9eI1njaDP4">
									<div className=" pb-6 md:pb-2">
										<div className="mx-auto max-w-[1400px]">
											<Person {...{ validation, formElementChanged }} />
											<BankAccount {...{ validation, formElementChanged }} />
											<Product {...{ validation, formElementChanged }} />
											<Mafo {...{ validation, formElementChanged }} />
										</div>
									</div>
									<div className="mx-auto max-w-[1400px]">
										<Receipt />
										<Legal {...{ validation, formElementChanged }} />
									</div>
								</GoogleReCaptchaProvider>
								<div className=" pb-2 md:pt-8" ref={animationRef}>
									<div className="mb-12">
										<div className="relative px-4 text-center">
											{formError && <Alert className={"my-4 font-bold text-errorred"}>{formError}</Alert>}

											<div className="relative inline-block">
												<button
													type="submit"
													className="mb-6 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
													disabled={isLoading ? true : undefined}
												>
													{isLoading && <Spinner />}
													jetzt teilnehmen!
												</button>
											</div>
											<p className="text-[12px] text-white md:text-[14px]">
												Informationen zum Datenschutz findest du{" "}
												<a href="https://www.alpro.com/de/datenschutzerklarung" rel={"noreferrer"} target="_blank" className="text-white underline">
													hier
												</a>
												.
											</p>
											<p className="before-border mx-auto mt-3 max-w-[450px] text-center text-[12px] leading-[50px] text-white text-white md:mb-6 md:text-[14px]  ">
												* Pflichtfelder
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</RedSection>
	)
}

export default Form
